import { useSelector } from 'react-redux';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import {
    getHasTrainingAtFacility,
    getHasWalkingAtFacility
} from 'reducers/services/ServicesSelectors';

export const useShouldShowFullAddress = (): boolean => {
    const marketplace = useSelector(getMarketplace);
    const hasTrainingAtFacility = useSelector(getHasTrainingAtFacility);
    const hasWalkingAtFacility = useSelector(getHasWalkingAtFacility);

    const { settings } = marketplace;

    return (
        hasTrainingAtFacility ||
        hasWalkingAtFacility ||
        settings.daycareEnabled ||
        settings.groomingEnabled ||
        settings.boardingEnabled ||
        settings.trainingEnabled ||
        settings.walkingEnabled
    );
};
